<div
  class="datetime-input flex flex-row flex-nowrap items-center justify-center"
>
  <div class="w-full gap-6 mr-1">
    <mat-form-field class="datetime-input__form-field" color="primary">
      <mat-label>{{ placeholder }}</mat-label>
      <input
        [attr.aria-label]="
          'datetime-input-' + placeholder.replace(' ', '-').toLowerCase()
        "
        matInput
        [id]="inputId"
        [type]="type"
        [min]="minDate"
        [max]="maxDate"
        [formControl]="_control"
        [placeholder]="placeholder"
        (focus)="setDefaultDateTime()"
        (ngModelChange)="onDateValueChange()"
      />
      <button
        mat-icon-button
        matIconSuffix
        class="material-icons transform scale-75 !p-1"
        (click)="$event.stopPropagation(); cleanDate()"
        (keyup)="(null)"
      >
        close
      </button>
      @if (_control.errors?.['invalidFutureDate']) {
        <mat-error class="text-sm">Cannot be a future date</mat-error>
      }
      @if (_control.errors?.['invalidEndDate']) {
        <mat-error class="text-sm">Cannot be prior to start date</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="flex flex-row mb-6">
    <button
      class="datetime-input__small-icon-button blue-theme-text-1"
      [matTooltip]="copyTooltipText"
      #tooltip="matTooltip"
      mat-icon-button
      color="primary"
      (click)="copy()"
      [disabled]="!_control.value"
    >
      <mat-icon>content_copy</mat-icon>
    </button>
    <button
      class="datetime-input__small-icon-button blue-theme-text-1"
      matTooltip="Paste"
      color="primary"
      mat-icon-button
      (click)="paste()"
    >
      <mat-icon>content_paste_go</mat-icon>
    </button>
  </div>
</div>
